import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const MobileHeader: React.FunctionComponent<{ visible: boolean }> = ({
  visible
}) => {
  const { headerContainer } = useStyles();
  if (!visible) return null;
  return (
    <div className={headerContainer}>
      <CustomizedTypography variant="h4" fontWeight="700">
        발주 관리
      </CustomizedTypography>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: 16,
    height: 68,
    borderBottom: `1px solid ${colorSet.gray400}`
  }
}));

export default MobileHeader;
